import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const DSPs = () => {
  const getAll = () =>
    AuthAxios.get(`${DataApiUrl}/dsps`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getById = id =>
    AuthAxios.post(`${DataApiUrl}/dsps/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const add = id =>
    AuthAxios.post(`${DataApiUrl}/dsps`, { id })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const update = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/dsps/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const destroy = id =>
    AuthAxios.delete(`${DataApiUrl}/dsps/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getAll,
    getById,
    add,
    update,
    destroy,
  };
};

export default DSPs;
